import HTMLTemplate from './template.html'
import './styles.scss'

export const ApplicationInfoModalComponent = (() => {
    const vueComponent = {
        data() {
            return {
                show: false,
                applicationInfo: [
                    { type: 'Alerts', source: 'MedAire/International SOS', frequency: 'As Issued', display: true },
                    { type: 'Tails', source: 'Flight Aware', frequency: 'Every 1 min', display: true },
                    { type: 'City/Country', source: 'MedAire/International SOS', frequency: 'On Request / Manually', display: true },
                    { type: 'Travel Restrictions', source: 'MedAire/International SOS', frequency: 'Twice Daily', display: true }
                ]
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-modal-application-info')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})()
